<template>
  <v-data-table :headers="headers" :items="registers" fixed-header>
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title class="headline font-weight-bold">Registers</v-toolbar-title>
        <v-chip color="primary" class="ml-2" dark>{{ registers.length }}</v-chip>
      </v-toolbar>
    </template>

    <!-- id format -->
    <template slot="item.global_id" slot-scope="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <span class="font-mono">{{ item.global_id.substring(0, 8) }}</span>
        </span>
      </template>
        {{ item.global_id }}
      </v-tooltip>
    </template>

    <!-- activation format -->
    <template slot="item.activation_code" slot-scope="{ item }">
        <span class="font-mono">{{ item.activation_code | formatActivationCode }}</span>
    </template>

    <!-- activity -->
    <template slot="item.activity" slot-scope="row">
      <span v-if="row.item.activated_at">
        <v-icon color="primary">mdi-progress-check</v-icon>
        <span class="small ml-2">{{ row.item.activated_at | date }}</span>
      </span>
      <v-icon v-else color="warning">mdi-information-outline</v-icon>
    </template>

    <!-- actions -->
    <template v-slot:item.action="{ item }">
      <generate-activation-code :register="item" @update:register="updateRegister" />
      <delete-register-action :register="item" @delete:register="deleteRegister" />
    </template>

    <!-- telemetries -->
    <template v-slot:item.telemetries="{ item }">
      <telemetry-details v-if='item.telemetries.length' :register="item" :telemetry="item.telemetries.at(-1)"/>
    </template>
    
  </v-data-table>
</template>
<script>
import { updateArrayEntry, deleteArrayEntry } from '@/store/utils';
import GenerateActivationCode from './generateActivationCode';
import DeleteRegisterAction from './deleteRegisterAction';
import TelemetryDetails from './telemetryDetails.vue';

export default {
  props: {
    client: {
      required: true,
    },
  },
  components: { GenerateActivationCode, DeleteRegisterAction, TelemetryDetails },
  data() {
    return {
      show: {
        telemtry: false
      },
      headers: [
        {
          text: 'Global ID',
          value: 'global_id',
        },
        {
          text: 'Local ID',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'data.name',
        },
        {
          text: 'Activation Code',
          value: 'activation_code',
        },
        {
          text: 'Activity',
          value: 'activity',
        },
        {
          text: 'Actions',
          value: 'action',
        },
        {
          text: 'Telemetries',
          value: 'telemetries',
        },
      ],
      registers: this.client.registers || { telemetries: []},
    };
  },

  methods: {
    updateRegister(register) {
      this.registers = updateArrayEntry(this.registers, register, 'id');
    },
    deleteRegister(register) {
      this.registers = deleteArrayEntry(this.registers, register, 'id');
    },
  },

  filters: {
    formatActivationCode(code) {
      if (!code) return '';

      var len = code.length;
      var offset = 0;
      var out = [];
      var index = 0;
      for (; offset < len; index++) {
        out[index] = code.slice(offset, offset +=4);
      }

      return out.join('-');
    },
  }
};
</script>
